import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AddressForm, AddressFormValidations, ButtonWithSpinner, Text } from '@reveni-io/reveni-ui'

import Summary from '../components/Summary/Summary'
import AppContext from '../context/AppContext'
import useExchangeAddressForm from './hooks/useExchangeAddressForm'
import { getExchangeDeliveryMethod } from './helpers'
import * as Styles from './styles'

const ExchangeAddressPage = () => {
  const { t } = useTranslation()
  const { context } = useContext(AppContext)
  const { updateExchangeAddress, handleContinue, exchangeShippingAddress, provinces, loading } =
    useExchangeAddressForm()

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t('Introduce la dirección a la que quieres que se envíen los nuevos productos solicitados.')}
      </Text>
      <AddressForm
        shippingAddress={exchangeShippingAddress}
        onChange={updateExchangeAddress}
        provinces={provinces}
        requiresHouseNumber={context?.orderInfo?.deliveryMethod?.requires_house_number}
        allowEditProvince
      />
      <Summary />
      <Styles.ActionsContainer>
        <ButtonWithSpinner
          type="submit"
          fullWidth
          onClick={handleContinue}
          defaultLabel={t('Continuar')}
          loading={loading}
          loadingLabel={t('Procesando')}
          disabled={
            loading ||
            !AddressFormValidations.isFormValid({
              deliveryMethod: getExchangeDeliveryMethod(context?.orderInfo?.deliveryMethod),
              address: exchangeShippingAddress,
              timeRange: context?.orderInfo?.selectedTimeRange,
              isProvinceRequired: context?.allowed_region?.provinces?.length > 0,
              phone: `+${exchangeShippingAddress?.phone?.prefix} ${exchangeShippingAddress?.phone?.number}`,
              specialConstraints: null,
              pickupDate: context?.orderInfo?.selectedPickupDate,
            })
          }
        />
      </Styles.ActionsContainer>
    </Styles.Container>
  )
}

export default ExchangeAddressPage
